import { Metrika } from '../lib/classes';
export var params = function (params) { return Metrika.params(params); };
export var error = function (error) { return Metrika.logError(error); };
export var goal = function (name) { return Metrika.goal(name); };
export var time = function (name, started) { return Metrika.logTime(name, started); };
export var button = function (name) {
    var _a;
    return params({ buttons: (_a = {}, _a[name] = 1, _a) });
};
